import { newsItems } from '@/mocks/routeData';

export default function NewsFeed() {
  return (
    <section id="news" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-orange-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">FEED · 线路快讯</span>
          </div>
          <h2 className="font-mag mt-3 text-2xl font-black text-stone-900 md:text-4xl">
            各线路最新动态，按时间流着看
          </h2>
        </div>
        <span className="shrink-0 text-xs text-stone-400">
          <i className="ri-refresh-line mr-1 align-[-1px]" /> 自动同步 · 更新于 09-07
        </span>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* 时间线 */}
        <div className="relative lg:col-span-2">
          <div className="absolute bottom-2 left-[7px] top-2 w-px bg-stone-200" />
          <ul className="space-y-4">
            {newsItems.map((n) => (
              <li key={n.title} className="relative flex gap-4 pl-8">
                <span className={`absolute left-0 top-6 flex h-[15px] w-[15px] rounded-full ring-4 ring-[#fbf8f3] ${n.dotClass}`} />
                <a
                  href="#news"
                  className="group flex flex-1 cursor-pointer flex-col gap-1 rounded-xl border border-stone-200/80 bg-white p-4 transition hover:border-orange-300"
                >
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className="text-stone-400">{n.date}</span>
                    <span className={`rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${n.tone === 'bg-orange-500' ? 'bg-orange-100 text-orange-700' : n.tone === 'bg-teal-500' ? 'bg-teal-100 text-teal-700' : n.tone === 'bg-rose-500' ? 'bg-rose-100 text-rose-700' : n.tone === 'bg-amber-500' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`}>
                      {n.type}
                    </span>
                  </div>
                  <h3 className="text-sm font-bold leading-snug text-stone-800 group-hover:text-orange-700 md:text-[15px]">
                    {n.title}
                  </h3>
                  <p className="text-xs text-stone-400">{n.sub}</p>
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#news"
            className="mt-4 flex cursor-pointer items-center justify-center gap-1 rounded-xl border border-dashed border-stone-300 bg-white/60 py-3 text-sm font-medium text-stone-500 transition hover:border-orange-300 hover:text-orange-600"
          >
            加载更早的快讯 <i className="ri-arrow-down-s-line" />
          </a>
        </div>

        {/* 侧栏：今日看板 */}
        <aside className="space-y-5">
          <div className="rounded-2xl bg-stone-900 p-5 text-white">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-orange-400">
              <i className="ri-dashboard-3-line" /> 今日线路看板
            </p>
            <div className="mt-4 grid grid-cols-2 gap-3">
              {[
                ['正常在线', '57', 'text-teal-300'],
                ['刚修复', '4', 'text-emerald-300'],
                ['换源中', '3', 'text-amber-300'],
                ['临时下线', '1', 'text-rose-300'],
              ].map(([k, v, c]) => (
                <div key={k} className="rounded-xl bg-white/5 p-3">
                  <b className={`block text-2xl font-black ${c}`}>{v}</b>
                  <span className="text-xs text-stone-300">{k}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-stone-200/80 bg-white p-5">
            <p className="mb-3 flex items-center gap-2 text-sm font-bold text-stone-900">
              <i className="ri-alarm-warning-line text-amber-500" /> 待补档预告
            </p>
            <ul className="space-y-3">
              {[
                '《白夜回声》第 10 集将于周六 21:00 更',
                '《长街灯》旧剧场版高清源预计下周补齐',
                '《雾港》第六季上线前将先发顺序预告',
              ].map((t) => (
                <li key={t} className="flex gap-2 text-[13px] leading-5 text-stone-500">
                  <i className="ri-time-line mt-0.5 shrink-0 text-orange-400" /> {t}
                </li>
              ))}
            </ul>
          </div>

          <a
            href="#forum"
            className="flex cursor-pointer items-center justify-between rounded-2xl border border-orange-200 bg-orange-50 p-5 transition hover:bg-orange-100"
          >
            <div>
              <p className="text-sm font-bold text-orange-800">想看某部的顺序没人整理？</p>
              <p className="mt-1 text-xs text-orange-600">去社区留个「求教」，会有人接单整理</p>
            </div>
            <i className="ri-arrow-right-circle-line text-xl text-orange-500" />
          </a>
        </aside>
      </div>
    </section>
  );
}